import { clientePedido } from '../../apiClient/index'

function initialState () {
  return {
    listaContactos: undefined
   }
}

const moduloContacto = {
  namespaced: true,
  state: initialState,
  actions: {
    getListaContactos(context) {
      
      // si la lista de contactos está inicializada no la vuelvo a buscar
      if(context.state.listaContactos !== undefined)
        return

      // busco la lista de contactos
      let payload = JSON.parse(window.localStorage.getItem('SistemaPedidoToken')).IdUsuario
      return clientePedido.get('api/Contacto/GetListaContactos?idUSuario=' + payload)
      .then(response => { 
         context.commit('setListaContactos', response.data);
      })
    },
    enviarMensaje(context, payload) {
      return new Promise((resolve) => {
        clientePedido.post('api/Contacto/EnviarMensaje', payload)
        .then(response => resolve(response.data))
      })
    }
  },
  mutations: {
    setListaContactos(state, payload)
    {
      state.listaContactos = payload
    },
  }
}

export default moduloContacto